import { render, staticRenderFns } from "./LoaderEntity.vue?vue&type=template&id=78f24e4b&scoped=true&lang=true&"
import script from "./LoaderEntity.vue?vue&type=script&lang=js&"
export * from "./LoaderEntity.vue?vue&type=script&lang=js&"
import style0 from "./LoaderEntity.vue?vue&type=style&index=0&id=78f24e4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f24e4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
